/**
 * Inputs: a place. Outputs: one navigation URL shared by the pin, map link, directions and driver card.
 */

import type { Place } from "./schema.ts";

export function mapsSearchUrl(query: string): string {
  return `https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(query)}`;
}

export function safeHttpUrl(value: string | null | undefined): string | null {
  if (!value) return null;
  const trimmed = value.trim();
  try {
    const url = new URL(trimmed);
    if (url.protocol === "https:" || url.protocol === "http:") return trimmed;
  } catch {
    return null;
  }
  return null;
}

export function nameAndAddressQuery(place: Pick<Place, "name" | "address">): string {
  return [place.name, place.address].filter((part): part is string => Boolean(part?.trim())).join(", ");
}

export function placeDirectionsUrl(place: Place): string {
  const stored = safeHttpUrl(place.mapsUrl);
  if (stored) return stored;
  if (place.coordinates?.verified) {
    const { lat, lng } = place.coordinates;
    return `https://www.google.com/maps/dir/?api=1&destination=${lat},${lng}`;
  }
  const query = nameAndAddressQuery(place);
  if (query) return mapsSearchUrl(query);
  return mapsSearchUrl(place.name);
}

export function verifiedMarkerSignature(places: Array<{ id: string; coordinates?: { lat: number; lng: number; verified: boolean } | null }>): string {
  return places
    .filter((place) => place.coordinates?.verified)
    .map((place) => `${place.id}:${place.coordinates!.lat}:${place.coordinates!.lng}`)
    .sort()
    .join("|");
}
